export default __webpack_public_path__ + "static/context-3cfc9ffa8a846919fd8f3ee5183b42cf.jpg";